import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IOrder, IOrderItem, IPlaceOrderBase } from '../../services/order.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ICheckoutTotalOptions } from '../../components/checkout-total/checkout-total.component';
import { IStore, ITranslatableText } from '../../services/store.service';
import { OrderService } from '../../services/order.service';
import { AlertController } from '@ionic/angular';
import { ItemRequestComponent } from '../../components/item-request/item-request.component';
import { StoreService } from '../../services/store.service';
//import * as moment from  'moment';
import moment from 'moment';
import { finalize } from 'rxjs/operators';
import { SettingService } from 'src/app/shared/services/setting.service';
import { environment } from 'src/environments/environment';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

interface itemDetailCombination{
  size: ITranslatableText,
  color: ITranslatableText
}
const CACHE_KEY = 'cartStorage';
@Component({
    selector: 'app-cart-modal',
    templateUrl: './cart-modal.component.html',
    styleUrls: ['./cart-modal.component.scss'],
    standalone: false
})
export class CartModalComponent implements OnInit, AfterViewInit {
  marginTop: number = 25;
  title: string = 'Nav.Cart';
  total: number = 3;
  screenWidth: number;
  orderPickupItems: IOrderItem[];
  orderDeliveryItems: IOrderItem[];
  orderShippingItems: IOrderItem[];
  orderSeatItems: IOrderItem[];
  orderTableItems: IOrderItem[];

  shippingCheckout: boolean = true;
  seatCheckout: boolean = true;
  deliveryCheckout: boolean = true;
  pickupCheckout: boolean = true;
  tableCheckout: boolean = true;
  multipleOrders: boolean = false;
  @Input() order: IOrder;
  @Input() store: IStore;
  @Input() orderType: string;
  @Input() fromDesktop: boolean;

  @Input() checkTwoForOneDiscounts: Function;
  selectedPropeties: itemDetailCombination;
  @ViewChild('content', {read: ElementRef, static:false}) content: ElementRef;
  @ViewChild('pickupToolBar', {read: ElementRef, static:false}) pickupToolBar: ElementRef;
  @ViewChild('pickupContent', {read: ElementRef, static:false}) pickupContent: ElementRef;
  @ViewChild('pickupGrid', {read: ElementRef, static:false}) pickupGrid: ElementRef;
  @ViewChild('pickupDiv', {read: ElementRef, static:false}) pickupDiv: ElementRef;
  @ViewChild('deliveryToolBar', {read: ElementRef, static:false}) deliveryToolBar: ElementRef;
  @ViewChild('deliveryContent', {read: ElementRef, static:false}) deliveryContent: ElementRef;
  @ViewChild('deliveryGrid', {read: ElementRef, static:false}) deliveryGrid: ElementRef;
  @ViewChild('deliveryDiv', {read: ElementRef, static:false}) deliveryDiv: ElementRef;
  @ViewChild('shippingToolBar', {read: ElementRef, static:false}) shippingToolBar: ElementRef;
  @ViewChild('shippingContent', {read: ElementRef, static:false}) shippingContent: ElementRef;
  @ViewChild('shippingGrid', {read: ElementRef, static:false}) shippingGrid: ElementRef;
  @ViewChild('shippingDiv', {read: ElementRef, static:false}) shippingDiv: ElementRef;
  @ViewChild('seatToolBar', {read: ElementRef, static:false}) seatToolBar: ElementRef;
  @ViewChild('seatContent', {read: ElementRef, static:false}) seatContent: ElementRef;
  @ViewChild('seatGrid', {read: ElementRef, static:false}) seatGrid: ElementRef;
  @ViewChild('seatDiv', {read: ElementRef, static:false}) seatDiv: ElementRef;
  @ViewChild('tableToolBar', {read: ElementRef, static:false}) tableToolBar: ElementRef;
  @ViewChild('tableContent', {read: ElementRef, static:false}) tableContent: ElementRef;
  @ViewChild('tableGrid', {read: ElementRef, static:false}) tableGrid: ElementRef;
  @ViewChild('tableDiv', {read: ElementRef, static:false}) tableDiv: ElementRef;
  continueBTN:boolean = true;

  stores: any;

  homersLayout: boolean = false;


  get logo() {
      if (environment.deviceApp)
        return '/assets/logo.png';
  
      return this.settingService.logo;
    }
  
    get icon() {
      if (environment.deviceApp)
        return '/assets/logo.png';
  
      if (!this.settingService.icon)
        return this.logo;
         
      return this.settingService.icon;
    }


  get subTotal(): number {
    let subTotal = 0;
    this.order.orderItems.forEach(item => {
      if(item){
        subTotal += item.price * item.quantity;
        item.options.forEach(option => {
          subTotal += (option.itemDetailCombination ? option.itemDetailCombination.price : option.price) * (option.quantity == null ? 1 : option.quantity) * (option.itemDetailCombination ? 1 : item.quantity);
        });
      }
    });
    return subTotal;
  }

  get pickupSubTotal(): number {
    let subTotal = 0;
    this.orderPickupItems.forEach(item => {
      if(item){
        subTotal += item.price * item.quantity;
        item.options.forEach(option => {
          subTotal += (option.itemDetailCombination ? option.itemDetailCombination.price : option.price) * (option.quantity == null ? 1 : option.quantity) * (option.itemDetailCombination ? 1 : item.quantity);
        });

        /*if (item.linkedItems != null) {
          if (item.linkedItems.length > 0) {
            item.linkedItems.forEach(link => {
              subTotal += link.price;
            });
          }
        }*/
      }
    });
    return subTotal;
  }

  get deliverySubTotal(): number {
    let subTotal = 0;
    this.orderDeliveryItems.forEach(item => {
      if(item){
        subTotal += item.price * item.quantity;
        item.options.forEach(option => {
          subTotal += (option.itemDetailCombination ? option.itemDetailCombination.price : option.price) * (option.quantity == null ? 1 : option.quantity) * (option.itemDetailCombination ? 1 : item.quantity);
        });

        /*if (item.linkedItems != null) {
          if (item.linkedItems.length > 0) {
            item.linkedItems.forEach(link => {
              subTotal += link.price;
            });
          }
        }*/
      }
    });
    return subTotal;
  }

  get shippingSubTotal(): number {
    let subTotal = 0;
    this.orderShippingItems.forEach(item => {
      if(item){
        subTotal += item.price * item.quantity;
        item.options.forEach(option => {
          subTotal += (option.itemDetailCombination ? option.itemDetailCombination.price : option.price) * (option.quantity == null ? 1 : option.quantity) * (option.itemDetailCombination ? 1 : item.quantity);
        });

       /* if (item.linkedItems != null) {
          if (item.linkedItems.length > 0) {
            item.linkedItems.forEach(link => {
              subTotal += link.price;
            });
          }
        }*/
      }
    });
    return subTotal;
  }

  get seatSubTotal(): number {
    let subTotal = 0;
    this.orderSeatItems.forEach(item => {
      if(item){
        subTotal += item.price * item.quantity;
        item.options.forEach(option => {
          subTotal += (option.itemDetailCombination ? option.itemDetailCombination.price : option.price) * (option.quantity == null ? 1 : option.quantity) * (option.itemDetailCombination ? 1 : item.quantity);
        });

       /* if (item.linkedItems != null) {
          if (item.linkedItems.length > 0) {
            item.linkedItems.forEach(link => {
              subTotal += link.price;
            });
          }
        }*/
      }
    });
    return subTotal;
  }

  get tableSubTotal(): number {
    let subTotal = 0;
    this.orderTableItems.forEach(item => {
      if(item){
        subTotal += item.price * item.quantity;
        item.options.forEach(option => {
          subTotal += (option.itemDetailCombination ? option.itemDetailCombination.price : option.price) * (option.quantity == null ? 1 : option.quantity) * (option.itemDetailCombination ? 1 : item.quantity);
        });

       /* if (item.linkedItems != null) {
          if (item.linkedItems.length > 0) {
            item.linkedItems.forEach(link => {
              subTotal += link.price;
            });
          }
        }*/
      }
    });
    return subTotal;
  }

  get totalOptions(): ICheckoutTotalOptions {
    return {
      hasDelivery: (this.order._deliveryType == "delivery"),
      deliveryFee: this.store.deliveryPrice,
      subTotal: this.subTotal,
      taxes: this.store.provinceTaxes,
      freeDelivery: this.store.freeDelivery,
      convenienceFee : this.store.convenienceFee,
      tip: 0
    };
  }
  get pickupTotalOptions(): ICheckoutTotalOptions {
    return {
      hasDelivery: false,
      deliveryFee: this.store.deliveryPrice,
      subTotal: this.pickupSubTotal,
      taxes: this.store.provinceTaxes,
      freeDelivery: this.store.freeDelivery,
      convenienceFee : this.store.convenienceFee,
      tip: 0
    };
  }
  get deliveryTotalOptions(): ICheckoutTotalOptions {
    return {
      hasDelivery: true,
      deliveryFee: this.store.deliveryPrice,
      subTotal: this.deliverySubTotal,
      taxes: this.store.provinceTaxes,
      freeDelivery: this.store.freeDelivery,
      convenienceFee : this.store.convenienceFee,
      tip: 0
    };
  }
  get shippingTotalOptions(): ICheckoutTotalOptions {
    return {
      hasDelivery: false,
      deliveryFee: this.store.deliveryPrice,
      subTotal: this.shippingSubTotal,
      taxes: this.store.provinceTaxes,
      freeDelivery: this.store.freeDelivery,
      convenienceFee : this.store.convenienceFee,
      tip: 0
    };
  }
  get seatTotalOptions(): ICheckoutTotalOptions {
    return {
      hasDelivery: false,
      deliveryFee: this.store.deliveryPrice,
      subTotal: this.seatSubTotal,
      taxes: this.store.provinceTaxes,
      freeDelivery: this.store.freeDelivery,
      convenienceFee : this.store.convenienceFee,
      tip: 0
    };
  }
  get tableTotalOptions(): ICheckoutTotalOptions {
    return {
      hasDelivery: false,
      deliveryFee: this.store.deliveryPrice,
      subTotal: this.tableSubTotal,
      taxes: this.store.provinceTaxes,
      freeDelivery: this.store.freeDelivery,
      convenienceFee : this.store.convenienceFee,
      tip: 0
    };
  }
  get readyTime(): string {
    if(this.order.orderTime != null){
      return  moment(this.order.orderTime, 'HH:mm').format('hh:mm A');
    }
    return moment().add((this.store.orderPrepareTimeMax), 'minutes').format('hh:mm A');
  }
  constructor(
    private modalCtrl: ModalController,
    //public translateService: TranslateService,
    private storeService: StoreService,
    public orderService: OrderService,
    private alertCtrl: AlertController,
    private loadService: LoaderService,
    public settingService: SettingService,
    private analytics: AnalyticsService,
    public translationService: TranslationService,
    private element: ElementRef
    ) { }

  ngOnInit() { 
    const hostElement = this.element.nativeElement;
    const host = hostElement;

    host.style.setProperty('--Checkout-Bar-Color', this.settingService.configuration.uIoptions?.mobileCheckoutBottomBarColor);
    host.style.setProperty('--Checkout-Bar-Text-Color', this.settingService.configuration.uIoptions?.mobileTextCheckoutBottomBarColor);




    this.screenWidth= window.innerWidth;
    localStorage.removeItem('editKey');
    localStorage.removeItem('editOptionKey');
    // if flagship, use loader somewhere else, don't want double loader
    /*if(this.settingService.configuration.useFlagShipRates && this.store.useFlagShipRates){
      this.storeService.getMenu(localStorage.getItem('StoreId'),this.order.orderDate, this.order.orderTime)
      .subscribe(item=>{
        this.stores=item;
      });
    } else {
      this.loadService.create().then(result=>{
        this.storeService.getMenu(localStorage.getItem('StoreId'),this.order.orderDate, this.order.orderTime)
        .pipe(finalize(()=>{
           result.dismiss();
        }))
        .subscribe(item=>{
          this.stores=item;
        });
      });
    }*/
    this.loadService.create().then(result => {
      this.storeService.getMenu(localStorage.getItem('StoreId'),this.order.orderDate, this.order.orderTime)
      .pipe(finalize(() => {
         result.dismiss();
      }))
      .subscribe(item => {
        this.stores = item;
      });
    });
    this.orderService.reOrder = false;
    this.storeService.getMenu(localStorage.getItem('StoreId'),this.order.orderDate, this.order.orderTime).subscribe(item => {
      this.stores = item;
    });
    this.setValues();

    if(this.settingService.configuration.uIoptions && this.settingService.configuration.homePageConfiguration != null && this.settingService.configuration.uIoptions?.homePageOption == 10) {
      this.homersLayout = true;
    } else {
      this.homersLayout = false;
    }
  }

  ngAfterViewInit(): void {
    this.setContentHeight();
  }

  setValues(){
    this.orderPickupItems = this.order.orderItems.filter(item => item.orderType == "pickup");
    this.orderDeliveryItems = this.order.orderItems.filter(item => item.orderType == "delivery");
    this.orderShippingItems = this.order.orderItems.filter(item => item.orderType == "shipping");
    this.orderSeatItems = this.order.orderItems.filter(item => item.orderType == "seat");
    this.orderTableItems = this.order.orderItems.filter(item => item.orderType == "table");

    //we need to filter out the items with quantity 0 from the UI, it generates empty row and breaks the cart UI
    this.filterOutZeroQuantity(this.orderPickupItems);
    this.filterOutZeroQuantity(this.orderDeliveryItems);
    this.filterOutZeroQuantity(this.orderShippingItems);
    this.filterOutZeroQuantity(this.orderSeatItems);
    this.filterOutZeroQuantity(this.orderTableItems);
  }

  removeItem(index: number, orderType: string) {
    this.analytics.sendItemUpdate(false, null, null, this.order, false, null, null, "removeItemToCart", false);

    if(orderType == 'pickup'){
      this.order.orderItems.splice(this.order.orderItems.findIndex(
        item => item == this.orderPickupItems[index]
      ), 1);
      this.orderPickupItems.splice(index, 1);
    } else if(orderType == 'delivery'){
      this.order.orderItems.splice(this.order.orderItems.findIndex(
        item => item == this.orderDeliveryItems[index]
      ), 1);
      this.orderDeliveryItems.splice(index, 1);
    } else if(orderType == 'shipping'){
      this.order.orderItems.splice(this.order.orderItems.findIndex(
        item => item == this.orderShippingItems[index]
      ), 1);
      this.orderShippingItems.splice(index, 1);
    } else if(orderType == 'table'){
      this.order.orderItems.splice(this.order.orderItems.findIndex(
        item => item == this.orderTableItems[index]
      ), 1);
      this.orderTableItems.splice(index, 1);
    } else if(orderType == 'seat'){
      this.order.orderItems.splice(this.order.orderItems.findIndex(
        item => item == this.orderSeatItems[index]
      ), 1);
      this.orderSeatItems.splice(index, 1);
    } 

    this.setContentHeight();
    //localStorage.clear();
    
    if(this.order.orderItems.length === 0) {
      localStorage.removeItem('StoreId');
      localStorage.removeItem(CACHE_KEY);
      localStorage.removeItem('TimeLimit');
      this.modalCtrl.dismiss();
    }

    localStorage[CACHE_KEY] = JSON.stringify(this.order.orderItems);
    this.checkTwoForOneDiscounts();
    this.setValues();
  }

  removeOptionItem(itemIndex: number, optionItemIndex: number, orderType: string) {
    if(orderType == 'pickup'){
      let orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderPickupItems[itemIndex]);
      this.order.orderItems[orderItemIndex].options.splice(optionItemIndex, 1);
      //this.orderPickupItems[itemIndex].options.splice(optionIndex, 1);
    } else if(orderType == 'delivery'){
      let orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderDeliveryItems[itemIndex]);
      this.order.orderItems[orderItemIndex].options.splice(optionItemIndex, 1);
    } else if(orderType == 'shipping'){
      let orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderShippingItems[itemIndex]);
      this.order.orderItems[orderItemIndex].options.splice(optionItemIndex, 1);
    } else if(orderType == 'table'){
      let orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderTableItems[itemIndex]);
      this.order.orderItems[orderItemIndex].options.splice(optionItemIndex, 1);
    } else if(orderType == 'seat'){
      let orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderSeatItems[itemIndex]);
      this.order.orderItems[orderItemIndex].options.splice(optionItemIndex, 1);
    }
    this.setContentHeight();
    localStorage[CACHE_KEY]=JSON.stringify(this.order.orderItems);
  }

  removeItemQuantity(itemIndex: number, orderType: string){
    let orderItemIndex = undefined;
    if(orderType == 'pickup'){
      orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderPickupItems[itemIndex]);
    } else if(orderType == 'delivery'){
      orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderDeliveryItems[itemIndex]);
    } else if(orderType == 'shipping'){
      orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderShippingItems[itemIndex]);
    } else if(orderType == 'table'){
      orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderTableItems[itemIndex]);
    } else if(orderType == 'seat'){
      orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderSeatItems[itemIndex]);
    }
    if(orderItemIndex != undefined && this.order.orderItems[orderItemIndex].quantity > 1){
      this.order.orderItems[orderItemIndex].quantity -= 1;
      localStorage[CACHE_KEY]=JSON.stringify(this.order.orderItems);
      this.checkTwoForOneDiscounts();
      this.setValues();
    }
  }

  addItemQuantity(itemIndex: number, orderType: string){
    let orderItemIndex = undefined;
    if(orderType == 'pickup'){
      orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderPickupItems[itemIndex]);
    } else if(orderType == 'delivery'){
      orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderDeliveryItems[itemIndex]);
    } else if(orderType == 'shipping'){
      orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderShippingItems[itemIndex]);
    } else if(orderType == 'table'){
      orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderTableItems[itemIndex]);
    } else if(orderType == 'seat'){
      orderItemIndex = this.order.orderItems.findIndex(item => item == this.orderSeatItems[itemIndex]);
    }
    if(orderItemIndex != undefined){
      this.order.orderItems[orderItemIndex].quantity += 1;
      localStorage[CACHE_KEY]=JSON.stringify(this.order.orderItems);
      this.checkTwoForOneDiscounts();
      this.setValues();
    }
  }

  
  trackClick(e: any)
  {
    if(e.target.id==="content")
    {
      this.modalCtrl.dismiss();
    }
  }
  async cancel() {
    localStorage.removeItem('editKey');
    localStorage.removeItem('editOptionKey');
    await this.modalCtrl.dismiss();
  }

  async editItem(currentItem, item, index) {
    //So current Item have all the information of the item added into the cart 
    //In the item we want the full information of the current Item
    for(let i = 0; i < this.order.orderItems.length; i++) {
      if(this.order.orderItems[i] == currentItem) {
        index = i;
        break;
      }
    }

    localStorage['editKey'] = index;

    let arr = [];



    this.stores.storeMenuCategories.map(menu => {
      menu.storeMenuCategoryItems.map(storeItem => {
        if(arr.length === 0) {
          if(storeItem.subItems && storeItem.subItems.length > 0) {
            storeItem.subItems.map(subItem => {
              if(subItem.id == currentItem.itemId) {
                arr.push(storeItem);
              }
            })
          }
          if(currentItem.itemId == storeItem.itemId) {
            arr.push(storeItem);
          }
        }
      })
    });

    item = arr[0];

    if(currentItem.itemDetailCombination) {
      let optionIndex = item.item.itemOptionCategories.length - 1;
      this.modalCtrl.dismiss({
        cancel: false,
        item: item,
        orderItem: currentItem,
        index: index,
        optionIndex: optionIndex,
        itemDetailCombination: this.selectedPropeties,
        back: false
      });
    }

    
    //arr.length if we cannot find this item inside the menu
    if(arr.length == 0) {
      this.alertCtrl.create({
        header:  'Item no longer exists',
        message: 'This item no longer available!',
        buttons: [
          {
            text: 'Okay',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              
            }
          }
        ]
      }).then(al => {
        al.present();
      });
      let arr = JSON.parse(localStorage['cartStorage']);
      arr = arr.filter(item => item.itemId !== currentItem.itemId);
      localStorage['cartStorage'] = JSON.stringify(arr);
      return;
    }
 
   let optionIndex = item.item.itemOptionCategories.length - 1;
    if(optionIndex >= 0) { 
      this.modalCtrl.dismiss({
        cancel: false,
        item: item,
        orderItem: currentItem,
        index: index,
        optionIndex: optionIndex,
        back: false
      });
    }
    this.setContentHeight();
  }

  async editItemV2(currentItem, item, index) {
    //So current Item have all the information of the item added into the cart 
    //In the item we want the full information of the current Item
    for(let i = 0; i < this.order.orderItems.length; i++) {
      if(this.order.orderItems[i] == currentItem) {
        index = i;
        break;
      }
    }

    localStorage['editKey'] = index;

    console.log(index);
    console.log(currentItem);

    //////////////////////////////////////////////////////////////////////////
    // this checks to see if the item still exists in the menu.
    let arr = [];
    
    this.stores.storeMenuCategories.map(menu => {
      menu.storeMenuCategoryItems.map(storeItem => {
        if(arr.length === 0) {
          if(storeItem.subItems && storeItem.subItems.length > 0) {
            storeItem.subItems.map(subItem => {
              if(subItem.id == currentItem.itemId) {
                arr.push(storeItem);
              }
            })
          }
          if(currentItem.itemId == storeItem.itemId) {
            arr.push(storeItem);
          }
        }
      })
    });

    item = arr[0];

    //////////////////////////////////////////////////////////////////////////
    //it checks the item array length from the menus. if its empty, then it means that the item isn't available and removes it from the cart
    if(arr.length == 0) {
      this.alertCtrl.create({
        header:  'Item no longer exists',
        message: 'This item no longer available!',
        buttons: [
          {
            text: 'Okay',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              
            }
          }
        ]
      }).then(al => {
        al.present();
      });
      let arr = JSON.parse(localStorage['cartStorage']);
      arr = arr.filter(item => item.itemId !== currentItem.itemId);
      localStorage['cartStorage'] = JSON.stringify(arr);
      return;
    }

    //////////////////////////////////////////////////////////////////////////
    // this is where we send the request back
    this.modalCtrl.dismiss({
      cancel: false,
      item: item,
      orderItem: currentItem,
      index: index,
      optionIndex: null, // we dont need option index as we will change the item instead
      back: false,
      fullItemEdit: true  // used for homers new layout
    });
  }

  async editOptionItem(currentItem, item, itemIndex, optionItemIndex) {
    //So current Item have all the information of the item added into the cart 
    //In the item we want the full information of the current Item
    for(let i = 0; i < this.order.orderItems.length; i++) {
      if(this.order.orderItems[i] == currentItem) {
        itemIndex = i;
        break;
      }
    }

    localStorage['editKey'] = itemIndex;
    localStorage['editOptionKey'] = optionItemIndex;
    let arr = [];
    this.stores.storeMenuCategories.map(menu => {
      menu.storeMenuCategoryItems.map(storeItem => {
          if(currentItem.itemId == storeItem.itemId) {
            arr.push(storeItem);
          }
          
          if(arr.length === 0) {
            storeItem.subItems.map(subItem => {
                if(subItem.id == currentItem.itemId) {
                  arr.push(storeItem);
                }
            })
          }
      })
    });

    item = arr[0];

    if(currentItem.itemDetailCombination) {
      let optionIndex = item.item.itemOptionCategories.length - 1;
      this.modalCtrl.dismiss({
        item: item,
        orderItem: currentItem,
        index: itemIndex,
        optionIndex: optionIndex,
        optionItemIndex: optionItemIndex
      });
    }

    
    //arr.length if we cannot find this item inside the menu
    if(arr.length == 0) {
      this.alertCtrl.create({
        header:  'Item no longer exists',
        message: 'This item no longer available!',
        buttons: [
          {
            text: 'Okay',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              
            }
          }
        ]
      }).then(al => {
        al.present();
      });

      let arr = JSON.parse(localStorage['cartStorage']);

      arr = arr.filter(item => item.itemId !== currentItem.itemId);

      localStorage['cartStorage'] = JSON.stringify(arr);

      return;
    }
 
   let optionIndex = item.item.itemOptionCategories.length - 1;
    if(optionIndex >= 0) { 
      this.modalCtrl.dismiss({
        cancel: false,
        item: item,
        orderItem: currentItem,
        index: itemIndex,
        optionIndex: optionIndex,
        back: false
      });
    }
    this.setContentHeight();
  }

  //To see the name of the items;
  getOptionName(name: any) { 
    if(name.translations) {
        return name.translations[this.translationService.getLanguage()];
    }
    
    return name; 
  }

  getItemName(item: any) { 
    if(item) {
      if(item.itemName.translations) {
        return item.itemName.translations[this.translationService.getLanguage()]
      } else {
        return item.itemName
      }
    }
  }

  private setContentHeight() {
    setTimeout(() => {
      let totalHeight: number = 0;
      let contents: any[] = [];

      if(this.tableContent) {
        this.tableContent.nativeElement.style.height = this.content.nativeElement.offsetHeight - this.tableToolBar.nativeElement.offsetHeight + 'px';
        this.tableGrid.nativeElement.style.height = this.tableContent.nativeElement.offsetHeight - this.tableDiv.nativeElement.offsetHeight + 'px';
        this.multipleOrders = false;
        return;
      }

      if(this.seatContent) {
        this.seatContent.nativeElement.style.height = this.content.nativeElement.offsetHeight - this.seatToolBar.nativeElement.offsetHeight + 'px';
        this.seatGrid.nativeElement.style.height = this.seatContent.nativeElement.offsetHeight - this.seatDiv.nativeElement.offsetHeight + 'px';
        this.multipleOrders = false;
        return;
      }

      if(this.pickupContent) {
        if(!this.deliveryContent && !this.shippingContent) {
          this.pickupContent.nativeElement.style.height = this.content.nativeElement.offsetHeight - this.pickupToolBar.nativeElement.offsetHeight + 'px';
          this.pickupGrid.nativeElement.style.height = this.pickupContent.nativeElement.offsetHeight - this.pickupDiv.nativeElement.offsetHeight + 'px';
          this.multipleOrders = false;
          return;
        }
        this.multipleOrders = true;
        let marginTopString = window.getComputedStyle(this.pickupDiv.nativeElement, null).getPropertyValue('margin-top');
        let marginTop: number = Number(marginTopString.substring(0, marginTopString.length - 2));
        let contentHeight = this.pickupGrid.nativeElement.offsetHeight + this.pickupDiv.nativeElement.offsetHeight +  marginTop; 
        this.pickupContent.nativeElement.style.height = contentHeight + 'px';
        totalHeight += (contentHeight + this.pickupToolBar.nativeElement.offsetHeight);
        contents.push(this.pickupContent);
      }

      if(this.deliveryContent) {
        if(!this.pickupContent && !this.shippingContent) {
          this.deliveryContent.nativeElement.style.height = this.content.nativeElement.offsetHeight - this.deliveryToolBar.nativeElement.offsetHeight + 'px';
          this.deliveryGrid.nativeElement.style.height = this.deliveryContent.nativeElement.offsetHeight - this.deliveryDiv.nativeElement.offsetHeight + 'px';
          this.deliveryToolBar.nativeElement.style.marginTop = 0 + 'px';
          this.multipleOrders = false;
          return;
        } else {
          this.multipleOrders = true;
          let marginTopString = window.getComputedStyle(this.deliveryDiv.nativeElement, null).getPropertyValue('margin-top');
          let marginTop: number = Number(marginTopString.substring(0, marginTopString.length - 2));
          let contentHeight = this.deliveryGrid.nativeElement.offsetHeight + this.deliveryDiv.nativeElement.offsetHeight + marginTop;
          this.deliveryContent.nativeElement.style.height = contentHeight + 'px';
          totalHeight += (contentHeight + this.deliveryToolBar.nativeElement.offsetHeight);
          if(this.pickupContent) {
            this.deliveryToolBar.nativeElement.style.marginTop = this.marginTop + 'px';
            totalHeight += this.marginTop;
          } else {
            this.deliveryToolBar.nativeElement.style.marginTop = 0 + 'px';
          }
          contents.push(this.deliveryContent);
        }
      }
      if(this.shippingContent) {
        if(!this.pickupContent && !this.deliveryContent) {
          this.shippingContent.nativeElement.style.height = this.content.nativeElement.offsetHeight - this.shippingToolBar.nativeElement.offsetHeight + 'px';
          this.shippingGrid.nativeElement.style.height = this.shippingContent.nativeElement.offsetHeight - this.shippingDiv.nativeElement.offsetHeight + 'px';
          this.shippingToolBar.nativeElement.style.marginTop = 0 + 'px';
          this.multipleOrders = false;
          return;
        }
        
        this.multipleOrders = true;
        let marginTopString = window.getComputedStyle(this.shippingDiv.nativeElement, null).getPropertyValue('margin-top');
        let marginTop: number = Number(marginTopString.substring(0, marginTopString.length-2));
        let contentHeight = this.shippingGrid.nativeElement.offsetHeight + this.shippingDiv.nativeElement.offsetHeight + marginTop;
        this.shippingContent.nativeElement.style.height = contentHeight + 'px';
        this.shippingToolBar.nativeElement.style.marginTop = this.marginTop + 'px';
        totalHeight += (contentHeight + this.shippingToolBar.nativeElement.offsetHeight + this.marginTop);
        contents.push(this.shippingContent);
      }
      if(this.content.nativeElement.offsetHeight > totalHeight) {
        let addSpaceAmount = (this.content.nativeElement.offsetHeight - totalHeight)/contents.length;
        for(let content of contents) {
          content.nativeElement.style.height = content.nativeElement.offsetHeight + addSpaceAmount + 'px';
        }
      }
    }, 150);
  }

  close(e) {
    //maybe we wont need when we ll have all three checkouts so cross check it 
    if(e.target.id == "carts") {
      this.modalCtrl.dismiss();
    }
  }

  checkModals() {
    //These lines of codes are important to show all three checkouts,
    // if(!this.deliveryCheckout && !this.pickupCheckout && !this.shippingCheckout)
    // {
    //   this.modalCtrl.dismiss();
    // } 
    // this.total--;
    this.modalCtrl.dismiss();
  }

  filterOutZeroQuantity(orderItems: IOrderItem[]) { 
    for (let i = 0; i < orderItems.length; i++) {
      for (let j = orderItems[i].options.length - 1; j > 0; j--) {
        if (orderItems[i].options[j].quantity == 0) {
            orderItems[i].options.splice(j, 1);
        }
      }     
    }
  }

  getImageSrc(item: any): string {
    const value = item._itemImage?.changingThisBreaksApplicationSecurity;

    if (!value) {
      return '';
    }

    // Remove CSS `url(...)`
    if (value.startsWith('url(')) {
      return value.slice(4, -1);
    }

    return value;
  }
}
